import { css } from '@emotion/react'
import { useState } from 'react'

import { colors, typo } from '~/@common/styles'
import Button from '~/@common/ui/(Button)/Button/Button'
import CheckboxInputLabel from '~/@common/ui/checkbox/CheckboxInputLabel'

type Props = {
  onConfirm: (skipNext: boolean) => void
  onCancel: () => void
}

export const CasSubmitConfirmModal = ({ onConfirm, onCancel }: Props) => {
  const [skipNext, setSkipNext] = useState(false)

  return (
    <>
      <div css={S.wrapper}>
        <p css={S.message}>
          정답을 제출하면 수정이 불가능해요.
          <br />
          그래도 다음 문제로 넘어갈까요?
        </p>
        <div css={S.buttonRow}>
          <Button
            theme="primary"
            size="small"
            className="subGray"
            onClick={onCancel}
            style={S.buttonStyle}
          >
            취소
          </Button>
          <Button
            theme="primary"
            size="small"
            onClick={() => onConfirm(skipNext)}
            style={S.buttonStyle}
          >
            제출 후 다음문제
          </Button>
        </div>
      </div>
      <CheckboxInputLabel
        css={S.skipLabel}
        onChange={(e) => setSkipNext(e.target.checked)}
      >
        다시 보지 않기
      </CheckboxInputLabel>
    </>
  )
}

export const casSubmitConfirmModalOpt = {
  modalName: 'cas-submit-confirm',
  hasCloseButton: false,
  modalStyle: {
    padding: '24px 22px',
  },
} as const

const S = {
  wrapper: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    width: 310px;
    padding: 24px 22px;
  `,
  message: css`
    ${typo.body02};
    color: var(--Colors-Gray-900);
    text-align: center;
  `,
  buttonRow: css`
    display: flex;
    gap: 12px;
    width: 212px;
  `,
  buttonStyle: {
    flex: '1 0 0',
    height: 40,
    padding: 10,
    borderRadius: 10,
  } as const,
  skipLabel: css`
    position: absolute;
    bottom: -31px;
  `,
}
